<div class="pto-project-cards-main-container">
  <div class="pto-project-cards-filters-container">
    <span class="projects-title">Projects</span>
    <p-button styleClass="sort-by-btn" (click)="op.toggle($event)">
      <img alt="logo" src="../../../../../assets/icons/projects-overview/sort_by_icon.svg"/>
      <span>Sort by</span>
    </p-button>
    <p-overlayPanel #op styleClass="pto-sort-by-overlay">
      <ng-template pTemplate>
        <div class="filter-option" *ngFor="let radio of radioButtons">
          <label class="d-flex gap-2 mb-0">
            <p-radioButton
              (onClick)="setFilterByScore()"
              [name]="'sort-by'" id="{{radio.id}}"
              [value]="radio"
              [(ngModel)]="selectedRadioButton">
            </p-radioButton>
            <span>{{radio.label}}</span>
          </label>
        </div>
      </ng-template>
    </p-overlayPanel>
    <div class="pto-indicators-dropdown">
      <p-dropdown
        [options]="projectDefaultCategories"
        [(ngModel)]="selectedIndicator"
        optionLabel="title"
        placeholder="Project health indicators"
        (onChange)="changeIndicator($event.value)"
        dropdownIcon="bi bi-caret-down-fill"
        [showClear]="true"
        dataKey="uuid">
      </p-dropdown>
    </div>
  </div>
  <div class="pto-cards-container">
    <div
      class="pto-card" *ngFor="let card of projectCards"
      [ngClass]="(selectedProjectCard && selectedProjectCard?.project.uuid === card.project.uuid) ? 'highlight-card' : ''"
      (click)="openQuickActionsMenu(card)">
      <div class="pto-card-labels">
        <div class="project-type-container">
          <span>{{card.project.projectType | uppercase}}</span>
        </div>
      </div>
      <span class="project-name">{{card.project.name}}</span>
      <div [ngClass]="{'indicator-selected' : selectedIndicator}" class="project-health-container"
           [ngStyle]="{'background-color':!selectedIndicator ?
                                           card.project.fadeColor :
                                           card?.indicators[selectedIndicator?.index]?.fadeColor}">
        <div [ngClass]="{'indicator-selected' : selectedIndicator}" class="project-health-title-and-rate">
          <app-dinamic-indicator-display *ngIf="selectedIndicator"
            [indicatorName]="selectedIndicator.slug" [color]="card?.indicators[selectedIndicator?.index]?.color"></app-dinamic-indicator-display>
          <span class="health-title mb-auto">{{ !selectedIndicator ? 'Project Health' : selectedIndicator.title }}</span>
        </div>
        <app-gauge-display *ngIf="!selectedIndicator"
          [value]="card.score"
          [width]="125"
          [height]="100"
          [trend]="null"
          [colorStart]="card.project.color"
          [colorEnd]="card.project.color"
          [backgroundColor]="'rgba(255, 255, 255, 1)'"
          [isOnProjectTeam]="false"
          [isOnTeamCodex]="false">
        </app-gauge-display>
        <div class="indicator-value-con" *ngIf="selectedIndicator">
          <span class="indicator-value-text">{{card?.indicators[selectedIndicator?.index]?.score}}</span>
          <span class="indicator-percent">%</span>
        </div>
      </div>
      <div class="pto-card-manager-container">
        <span class="pto-card-manager-title">Project Manager:</span>
        <div class="d-flex align-items-center gap-2">
          <img class="manager-avatar"
               [src]="(card.project.leader.user?.avatar !== null && card.project.leader.user.avatar?.path !== null) ?
                       baseUrl + card.project.leader.user.avatar?.path: '../../../assets/svg/user-icon.svg'"
               alt="icon">
          <span class="manager-name">
            {{card.project.leader.user.detail.displayName ?
              card.project.leader.user.detail.displayName :
              (card.project.leader.user.detail.firstname ||
                card.project.leader.user.detail.lastname) ?
                card.project.leader.user.detail.firstname+' '+card.project.leader.user.detail.lastname :
                card.project.leader.user.email}}
          </span>
        </div>
      </div>
      <app-quick-actions-menu *ngIf="(selectedProjectCard && selectedProjectCard?.project.uuid === card.project.uuid)"
        [cardData]="this.selectedProjectCard"
        [vm$]="menuData$"
      ></app-quick-actions-menu>
    </div>
  </div>
</div>
